/* eslint-disable react/jsx-curly-newline */
import * as React from 'react';

import useClock from '@/hooks/date/useClock';
import { Race, RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { getVelodromeByCode } from '@/lib/race/velodrome';
import { RaceInfoType } from '@/modelTypes';
import { raceSelector } from '@/selectors/race';

import {
  BetButtonLink,
  DisabledResultButton,
  RaceStopButton,
  ResultButtonLink,
} from './style';

interface ButtonProps {
  raceProgram: RaceProgram;
  race: Race;
}

const Button: React.FC<ButtonProps> = ({ raceProgram, race }) => {
  const currentTime = useClock();
  if (raceProgram.isCanceled || raceSelector(race).isCanceled) {
    return <RaceStopButton>中止</RaceStopButton>;
  }
  if (race.singleRaceRefunds.length > 0) {
    return (
      <ResultButtonLink
        to={`/${
          getVelodromeByCode(raceProgram.velodromeCode).romanName
        }/race/${raceProgram.heldDate.format('YYYY-MM-DD')}/${
          race.raceNum
        }?infoType=${RaceInfoType.Result}`}
      >
        結果
      </ResultButtonLink>
    );
  }
  if (raceSelector(race).marginedOrderDeadline.isAfter(currentTime)) {
    return (
      <BetButtonLink
        to={`/${
          getVelodromeByCode(raceProgram.velodromeCode).romanName
        }/race/${raceProgram.heldDate.format('YYYY-MM-DD')}/${race.raceNum}`}
      >
        投票
      </BetButtonLink>
    );
  }
  return <DisabledResultButton>結果</DisabledResultButton>;
};

export default Button;
